import { useMenus } from '../../../../hooks/useMenus';
import { ITEM_TAG_OPTIONS } from '../../../../utils/itemTags';
import { VARIETY_LABELS, VARIETY_LEVELS } from '../mealPlannerOptions';

export const ExclusionsStep = ({ excludedTags, excludedItemIds, varietyLevel, onChange }) => {
  const { customFields } = useMenus();

  const toggleTag = (tag) => {
    const next = excludedTags.includes(tag) ? excludedTags.filter((t) => t !== tag) : [...excludedTags, tag];
    onChange({ excludedTags: next });
  };

  const toggleItem = (itemId) => {
    const next = excludedItemIds.includes(itemId)
      ? excludedItemIds.filter((id) => id !== itemId)
      : [...excludedItemIds, itemId];
    onChange({ excludedItemIds: next });
  };

  return (
    <div className="meal-planner-step">
      <h2 className="meal-planner-step__title">Anything to avoid?</h2>
      <p className="meal-planner-step__sub">Exclude whole categories or specific foods.</p>

      <h3 className="meal-planner-step__subtitle">Avoid these tags</h3>
      <div className="meal-planner-step__tag-list">
        {ITEM_TAG_OPTIONS.map((tag) => (
          <label key={tag.value} className="meal-planner-step__tag-option">
            <input
              type="checkbox"
              checked={excludedTags.includes(tag.value)}
              onChange={() => toggleTag(tag.value)}
            />
            {tag.label}
          </label>
        ))}
      </div>

      <h3 className="meal-planner-step__subtitle">Avoid specific foods</h3>
      <div className="meal-planner-step__item-groups">
        {(customFields ?? []).map((field) => (
          <div key={field.id} className="meal-planner-step__item-group">
            <div className="meal-planner-step__item-group-name">{field.name}</div>
            {(field.fieldItems ?? []).map((item) => (
              <label key={item.id} className="meal-planner-step__tag-option">
                <input
                  type="checkbox"
                  checked={excludedItemIds.includes(item.id)}
                  onChange={() => toggleItem(item.id)}
                />
                {item.name}
              </label>
            ))}
          </div>
        ))}
      </div>

      <h3 className="meal-planner-step__subtitle">Variety</h3>
      <div className="meal-planner-step__variety">
        {VARIETY_LEVELS.map((level) => (
          <button
            key={level}
            type="button"
            className={`meal-planner-step__variety-option${varietyLevel === level ? ' active' : ''}`}
            onClick={() => onChange({ varietyLevel: level })}
          >
            {VARIETY_LABELS[level]}
          </button>
        ))}
      </div>
    </div>
  );
};
